import angular from 'angular';
import oclazyload from 'oclazyload';
import gravityModule from './gravity';

angular.module('7Terminal.Modules', [
  oclazyload,
  gravityModule
]);
